import { render, staticRenderFns } from "./RenewPolicyModal.vue?vue&type=template&id=19541c33"
import script from "./RenewPolicyModal.vue?vue&type=script&lang=js"
export * from "./RenewPolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports